/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { Screen, Title, Subtitle } from '../_shared/Screen';
import { PrimaryButton } from '../_shared/PrimaryButton';
import { Reviews } from '../_shared/Reviews';

const REVIEWS = ['ryan', 'daniel', 'marcus'];

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-social-proof' });
  }, []);

  const next = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-social-proof' });
    onNext();
  };

  return (
    <Screen
      progress={46}
      hideBack={currentIndex === 0}
      onBack={onPrev}
      footer={<PrimaryButton onClick={next}>{t('hairstyleSocialProof.cta')}</PrimaryButton>}
    >
      <Title>{t('hairstyleSocialProof.title')}</Title>
      <Subtitle>{t('hairstyleSocialProof.subtitle')}</Subtitle>
      <div style={{ marginTop: 24 }}>
        <Reviews ns="hairstyleSocialProof" ids={REVIEWS} />
      </div>
    </Screen>
  );
}

export default Page;
